<template>
    <div class="rlt">
      <div class="-en-x abs .f l20-t d1-t" style="background-image: linear-gradient(to right, rgba(244, 67, 54, 0.4), rgba(255, 152, 0, 0.2), rgba(76, 175, 80, 0.2));mask-image: linear-gradient(rgb(0, 0, 0), transparent);"></div>
      <div class="-en-x abs .t .s w-f h-2" style="background-image: linear-gradient(to right, rgb(244, 67, 54), rgb(255, 152, 0), rgb(76, 175, 80));"></div>
      <div class="rlt -z-1 h-8">
          <i class="material-icons abs .s .t u-8 -pe-n c-grn-t">public</i>
          <select class="fld fld-n p-x-8 abs .f -aprnc c-grn-t Case" v-model="group">
              <option v-for="(_group, index) in Object.keys(groups.all)" :key="index" :value="_group">{{ groups.all[_group].name[$i18n.locale] }}</option>
          </select>
          <i class="material-icons abs .e .t u-8 -pe-n c-rd-t">keyboard_arrow_down</i>
      </div>

      <div class="b rlt -z-1">
          <div class="c-grn-t p-x-5 w-f">
            <div class="#9 m:#8 l:#8 Case o-7 b b-a-c">
                {{ $t('recover') }}
                <span class="-d-if h-5 m-e-n p-x-3 bdg bdg-s b-c -r-c c-grn c-20-t font-en w#9">{{ getSelectedCountriesTotal().recoveredP }}</span>
            </div>
            <div class="#7 m:#7 l:#6 xl:#5 l:lh-8 w#9 font-en">{{ getSelectedCountriesTotal().recovered }}</div>
            <div class="#10 o-8">{{ getSelectedCountriesTotal().active }} {{ $t('active') }}</div>
          </div>
          <div class="c-orng-t m:p-x-5 w-f">
            <div class="#9 m:#8 l:#8 Case o-7 b b-a-c">
                {{ $t('cases') }}
                <span class="-d-if h-5 m-e-n p-x-3 bdg bdg-s b-c -r-c c-orng c-20-t font-en w#9">{{ convert(getSelectedCountriesTotal().casesPerOneMillion) }}/<span class="font-ar">M</span></span>
            </div>
            <div class="#7 m:#7 l:#6 xl:#5 l:lh-8 w#9 font-en">{{ getSelectedCountriesTotal().cases }}</div>
            <div class="#10 o-8">{{ getSelectedCountriesTotal().todayCases }} {{ $t('today') }}</div>
          </div>
          <div class="c-rd-t p-x-5 w-f">
            <div class="#9 m:#8 l:#8 Case o-7 b b-a-c">
                {{ $t('deaths') }}
                <span class="-d-if h-5 m-e-n p-x-3 bdg bdg-s b-c -r-c c-rd c-20-t font-en w#9">{{ getSelectedCountriesTotal().deathsP }}</span>
            </div>
            <div class="#7 m:#7 l:#6 xl:#5 l:lh-8 w#9 font-en">{{ getSelectedCountriesTotal().deaths }}</div>
            <div class="#10 o-8">{{ getSelectedCountriesTotal().todayDeaths }} {{ $t('today') }}</div>
          </div>
      </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SummaryWidget',
  computed: {
    ...mapState(['countriesData', 'groups', 'selectedGroup']),
    ...mapGetters(['getSelectedCountries', 'getSelectedCountriesTotal'])
  },
  data () {
    return {
      group: null,
      started: false
    }
  },
  methods: {
    convert (number) {
      var _number
      if (number < 1000) {
        _number = number.toFixed(1) * 1
      } else if (number >= 1000 && number < 1000000) {
        var toFix = number < 10000 ? 1 : 0
        _number = ((number / 1000).toFixed(toFix) * 1) + 'K'
      } else {
        _number = ((number / 1000000).toFixed(1) * 1) + 'M'
      }
      return _number
    }
  },
  watch: {
    group (to, from) {
      if (this.started) {
        this.$router.push({ query: { ...this.$route.query, group: to } })
      } else {
        this.started = 1
      }
    }
  },
  mounted () {
    this.group = Object.entries(this.$store.state.groups.all).find(item => item[1].name.en === this.$store.state.groups.group.name.en)[0]
  }
}
</script>
<style lang="scss">
